import { render, staticRenderFns } from "./evalProject.vue?vue&type=template&id=5228e6a9&scoped=true&"
import script from "./evalProject.vue?vue&type=script&lang=js&"
export * from "./evalProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5228e6a9",
  null
  
)

export default component.exports